export enum GlobalSearchEnum {
  ITEM_KEY_CASES = 'cases',
  ITEM_KEY_PROBLEM_RECORDS = 'problemRecords',
  ITEM_KEY_KNOWLEDGE_LIBRARY = 'knowledgeLibrary',
  GRID_URL_CASES = 'cases',
  GRID_URL_PROBLEM_RECORDS = 'problem-records',
  GRID_URL_KNOWLEDGE_LIBRARY = 'knowledge-library',
}
